import React, { useEffect, useState, useCallback, useContext } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { GET_DASHBOARD_ITEMS } from '../graphql/queries'
import { UPDATE_DASHBOARD_ITEM } from '../graphql/mutations'

async function useQueryUpdater() {
    const [updateDashboardItem] = useMutation(UPDATE_DASHBOARD_ITEM, {
        refetchQueries: [
            {
                query: GET_DASHBOARD_ITEMS,
            },
        ],
    })

    const updateQuery = useCallback(async (dashboardItem) => {
        try {
            await (updateDashboardItem)({
                variables: {
                    id: dashboardItem.id,
                    input: {
                        vizState: dashboardItem.vizState,
                        name: dashboardItem.name
                    },
                },
            });
        } catch (err) {
            console.log("Error updating query: ", err)
        }
    })

    return { updateQuery }


}

export default useQueryUpdater


